import CrudList from "@/pages/admin/CrudList";
export default function AdminBrands() {
    return <CrudList endpoint="/admin/brands" title="Marcas" subtitle="Catálogo" testPrefix="brand" />;
}
